import $ from 'jquery';

function TopSliderCtrl() {
	this.$target      = $('.split-container');
	this.$targetLeft  = this.$target.children('.split-left');
	this.$targetRight = this.$target.children('.split-right');
	this.$leftItem    = this.$targetLeft.children('.item');
	this.$rightItem   = this.$targetRight.children('.item');
	this.leftLength = this.$leftItem.length;
	this.rightLength = this.$rightItem.length;
	this.sliderInit = this.$target.html();

	this.duration = 6000;
	this.now      = 0;
	this.interval;
	this.time;

	this.start = this.start.bind(this);
	this.slide = this.slide.bind(this);

	// this.init(8000);
}

TopSliderCtrl.prototype.init = function(interval_time) {
	this.time = interval_time;
	this.start();
	this.$leftItem.eq(this.now).addClass('now');
	this.$rightItem.eq(this.now).addClass('now');
}

TopSliderCtrl.prototype.start = function() {
	if (this.$leftItem.length <= 1) return;
	clearInterval(this.interval);
	this.interval = setInterval(this.slide, this.time);
}

TopSliderCtrl.prototype.slide = function() {
	let next = this.now + 1;
	if (next >= this.leftLength) {
		next = 0;
	}

	function add(elem, next, className = String) {
		elem.forEach((val, index) => {
			val.eq(next).addClass(className);
		})
	}

	function remove(elem, next, className) {
		elem.forEach((val, index) => {
			val.eq(next).removeClass(className);
		})
	}

	add([this.$leftItem, this.$rightItem], next, 'next');

	setTimeout(() => {
		add([this.$leftItem, this.$rightItem], next, 'now');
		remove([this.$leftItem, this.$rightItem], this.now, 'now');
		remove([this.$leftItem, this.$rightItem], next, 'next');

		this.now = next;
	}, this.duration + 50);
}

export default TopSliderCtrl;